// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p4-1";
export var stateContainer = "_p4-0";